import { render } from "./EditTopCompetencesModal.vue?vue&type=template&id=17a48c44&scoped=true"
import script from "./EditTopCompetencesModal.vue?vue&type=script&lang=js"
export * from "./EditTopCompetencesModal.vue?vue&type=script&lang=js"

import "./EditTopCompetencesModal.vue?vue&type=style&index=0&id=17a48c44&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a48c44"]])

export default __exports__